import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadsService {

  constructor(private http: HttpClient) { }

  uploadProfileImage(formData: any){
    return this.http.post(`${environment.apiUrl}/v1/uploads/profile`, formData);
  }

  getProfileImage(){
    return this.http.get<any>(`${environment.apiUrl}/v1/uploads/profile-images`);
  }

  uploadFile(formData: any, userId: bigint){
    return this.http.post(`${environment.apiUrl}/v1/uploads/uploadFile/` + userId, formData);
  }

  getUpload(url : any){
    return this.http.get<any>(url);
  }

  getUploads(){
    return this.http.get<any>(`${environment.apiUrl}/v1/uploads`);
  }

  deleteUpload(id : bigint){
    return this.http.delete<any>(`${environment.apiUrl}/v1/uploads/`+id);
  }
}
